var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 -960 960 960",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M478.304-145.869q-138.652 0-236.392-97.739-97.739-97.74-97.739-236.253 0-138.513 97.739-236.674 97.74-98.161 236.392-98.161 88.392 0 155.441 35.756t115.864 98.896v-134.652h66.783v274.914H540.913V-606h165.739q-38.565-57.739-95.304-93.326-56.739-35.587-133.044-35.587-106.88 0-180.896 73.987-74.017 73.987-74.017 180.826t74.021 180.926q74.021 74.087 180.908 74.087 80.158 0 147.745-46.087T721.217-393h81.784q-29.566 110.652-119.667 178.892-90.101 68.239-205.03 68.239Z"
  })));
}
export default SvgRefresh;